/**
 * Simply remove the no-js classname from the document body
 */
export const updateBodyClassname = () => {
	document.body.classList.remove('no-js');

    /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
    var prevScrollpos = window.pageYOffset;
    /* Get the header element and it's position */
    var headerDiv = document.querySelector("header");
    var stickyNav = document.getElementById("sticky-nav-holder");
    var headerBottom = headerDiv.offsetTop + headerDiv.offsetHeight;

    window.onscroll = function() {
      var currentScrollPos = window.pageYOffset;
      /* if we're scrolling up, or we haven't passed the header,
         show the header at the top */
      if (prevScrollpos > currentScrollPos  || currentScrollPos < headerBottom){
        /* if the user is logged in add 30px to the header hide to keep the full header on screen and not have it cut off*/
        var isLoggedin = document.getElementsByClassName('logged-in');
        if (isLoggedin.length > 0) {
            headerDiv.style.top = "30px";
            if(stickyNav){
                stickyNav.classList.remove('sticky-nav-position');
            }
        } else {
            headerDiv.style.top = "0";
            if(stickyNav){
                stickyNav.classList.remove('sticky-nav-position');
            }
        }
      }
      else{
        /* otherwise we're scrolling down & have passed the header so hide it */
        headerDiv.style.top = "-7rem";
        if(stickyNav){
            stickyNav.classList.add('sticky-nav-position');
        }
      } 

      prevScrollpos = currentScrollPos;
    }

    var scrollButt = document.getElementById("click-to-scroll");
    if(scrollButt){
        document.getElementById('click-to-scroll').addEventListener('click', function(){
           var elmnt = document.getElementById("scroll-to-here");
          elmnt.scrollIntoView();
        });
    }
};
